import { CheckImageIsFile, CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { GetFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";
import { PostFunction } from "src/utils/axios_connection";
import { toast } from "react-toastify";

export const GetCourseFiles =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.course_files.get;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetCourses =
  ({ callback, page, rowsPerPage, search }) =>
  async (dispatch, getState) => {
    try {
      const query = search
        ? `?search=${search}&limit=${1000}&page=${0}`
        : `?page=${page}&limit=${rowsPerPage}`;

      let link = UrlApi.courses.get + query;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const GetCategories =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.categories.get;
      const response = await GetFunction({
        data: {},
        Route: link,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const DeleteCourse =
  ({ courseId, callback }) =>
  async (dispatch, getState) => {
    try {
      let link = UrlApi.courses.delete;
      const response = await GetFunction({
        data: {},
        Route: link + `/${courseId}`,
        showalert: false,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageCourse =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      var bodyFormData = new FormData();
      let paramID = "";
      if (editMode) {
        paramID = values?.id;
      }
      console.log({ values123: values });
      if (CheckDataIfExit(values?.name)) {
        bodyFormData.append("name", values?.name?.trim());
      }
      if (CheckDataIfExit(values?.description)) {
        bodyFormData.append("description", values?.description?.trim());
      }
      if (CheckDataIfExit(values?.date)) {
        bodyFormData.append("date", values?.date);
      }
      if (CheckDataIfExit(values?.secondary_date)) {
        bodyFormData.append("secondary_date", values?.secondary_date);
      }
      if (CheckDataIfExit(values?.objectives)) {
        bodyFormData.append("objectives", values?.objectives?.toString());
      }
      if (CheckDataIfExit(values?.duration)) {
        bodyFormData.append("duration", values?.duration);
      }
      if (CheckDataIfExit(values?.price)) {
        bodyFormData.append("price", values?.price);
      }
      if (values?.course_category_id) {
        bodyFormData.append("course_category_id", values?.course_category_id);
      }
      if (CheckDataIfExit(values?.is_featured)) {
        bodyFormData.append("is_featured", values?.is_featured);
      }
      if (CheckDataIfExit(values?.is_workshop)) {
        bodyFormData.append("is_workshop", values?.is_workshop);
      }
      if (CheckDataIfExit(values?.zoom_link)) {
        bodyFormData.append("zoom_link", values?.zoom_link);
      }
      if (CheckDataIfExit(values?.workshop_info)) {
        bodyFormData.append("workshop_info", values?.workshop_info);
      }

      if (
        values?.image &&
        values?.image != null &&
        values?.image != undefined &&
        CheckImageIsFile({ data: values?.image, IsBoolean: true })
      ) {
        bodyFormData.append("image", values?.image);
      } else if (editMode && !values?.image) {
        bodyFormData.append("image", "");
      }
      if (
        values?.demo_video &&
        values?.demo_video != null &&
        values?.demo_video != undefined &&
        CheckImageIsFile({ data: values?.demo_video, IsBoolean: true })
      ) {
        bodyFormData.append("demo_video", values?.demo_video);
        if (!values?.duration) {
          return toast.error("Please provide duration");
        }
      } else if (editMode && !values?.demo_video) {
        bodyFormData.append("demo_video", "");
      }
      console.log({ bodyFormDatabodyFormData: bodyFormData });
      const response = await PostFunction({
        data: bodyFormData,
        Route: editMode
          ? `${UrlApi.courses.edit}/${paramID}`
          : UrlApi.courses.add,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      console.error(err);
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditCourses =
  ({ callback, allData, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      let data;
      if (allData) {
        data = allData;
      } else {
        data = {
          [nameFailed]: dataFailed,
        };
      }
      const response = await PostFunction({
        data,
        Route: UrlApi.courses.edit + `/${id}`,
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
        usersRoute: true,
      });
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };
